import Vue from 'vue'

const FilterHelper = {
  methods: {
    deleteBrowserCacheQuery() {
      if (this.checkVariable(this.url)) {
        localStorage.removeItem(this.replaceAll(`filter-index-${this.url}-query`, '/', ''))
      }
    },
    deleteBrowserCacheFilterCandidates() {
      if (this.checkVariable(this.url)) {
        localStorage.removeItem(this.replaceAll(`filter-index-${this.url}-filterCandidates`, '/', ''))
      }
    },
    deleteCachePaginationDetail(showPath) {
      if (this.checkVariable(this.url)) {
        localStorage.removeItem(`show-${showPath}`)
      }
    },
    updateCacheQuery() {
      this.deleteBrowserCacheQuery()
      let query = ''
      if (this.getAmountOfKeys(this.query) > 0) {
        query = JSON.stringify(this.query)
      }
      localStorage.setItem(this.replaceAll(`filter-index-${this.url}-query`, '/', ''), query)
    },
    updateCache() {
      this.deleteBrowserCacheFilterCandidates()
      this.updateCacheQuery()
      let filterCandidates = ''
      if (this.getAmountOfKeys(this.filterCandidates) > 0) {
        filterCandidates = JSON.stringify(this.filterCandidates)
      }
      localStorage.setItem(this.replaceAll(`filter-index-${this.url}-filterCandidates`, '/', ''), filterCandidates)
    },
    /**
     * @param {String} showPath
     */
    updateCachePaginationDetail(showPath) {
      if (this.checkVariable(this.url)) {
        this.deleteCachePaginationDetail(showPath)
        localStorage.setItem(`show-${showPath}`, this.url)
      }
    },
  },
}

const Component = Vue.extend({
  name: 'helper-filter',
  mixins: [FilterHelper],
})

export default Component
